import { ModelBase, Property } from '@skylab-shared/core';
import { SaleDocumentKind } from '@skylab-shared/dataModel';
import { OrderRecipientAddressModel } from './order-recipient-address.model';

export class OrderDocumentModel extends ModelBase {
	@Property()
	public documentType: SaleDocumentKind;

	@Property(OrderRecipientAddressModel, {nullable: true})
	public address: OrderRecipientAddressModel | null;

	@Property()
	public name: string;

	@Property()
	public taxIdentification: string;
}
